exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adMoreMenu__manageButton___3hYyX {\n  cursor: pointer;\n  position: absolute;\n  right: 15px;\n  top: 20px;\n  z-index: 2;\n  padding: 10px 0;\n  line-height: 0;\n  font-size: 30px; }\n  .adMoreMenu__manageButton___3hYyX::before {\n    color: #3f3f3f; }\n\n.adMoreMenu__menuItem___2Wg9R {\n  padding: 5px 15px; }\n\n@media (max-width: 576px) {\n  .adMoreMenu__manageButton___3hYyX {\n    top: 10px;\n    right: 10px; } }\n", ""]);

// exports
exports.locals = {
	"manageButton": "adMoreMenu__manageButton___3hYyX",
	"menuItem": "adMoreMenu__menuItem___2Wg9R"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AdCard/AdMoreMenu/adMoreMenu.scss
// module id = 3927
// module chunks = 6